import debounce from 'lodash/debounce'

import { onDocumentEvent, getNavbarHeight } from '@app/utils/domHelpers'
import { isUsingNewLayout } from '@app/adapters/silverfin'

let updateBodyPaddingFrame: ReturnType<typeof requestAnimationFrame>

const updateBodyPadding = (): void => {
  if (isUsingNewLayout()) {
    return
  }

  cancelAnimationFrame(updateBodyPaddingFrame)
  updateBodyPaddingFrame = window.requestAnimationFrame(() => {
    const updatedHeight = getNavbarHeight()

    if (updatedHeight) {
      document.body.style.paddingTop = `${getNavbarHeight()}px`
    }
  })
}

let delayedUpdateBodyPaddingTimeout: ReturnType<typeof setTimeout>

const delayedUpdateBodyPadding = (): void => {
  window.clearTimeout(delayedUpdateBodyPaddingTimeout)
  delayedUpdateBodyPaddingTimeout = setTimeout(updateBodyPadding, 350)
}

const updateBodyPaddingDebouncedTrailing = debounce(updateBodyPadding, 30, {
  leading: false,
  trailing: true,
})

onDocumentEvent(document, 'turbolinks:load', null, updateBodyPadding)
onDocumentEvent(
  window,
  'resize.navbar-height-monitoring',
  null,
  updateBodyPaddingDebouncedTrailing
)

onDocumentEvent(
  document,
  'shown',
  '.navbar-fixed-top .nav-collapse',
  updateBodyPadding
)

onDocumentEvent(
  document,
  'hidden',
  '.navbar-fixed-top .nav-collapse',
  updateBodyPadding
)

window.onDomLoad(() => {
  delayedUpdateBodyPadding()
})
